import Nav from 'react-bootstrap/Nav'
import Icon from '../../../components/Icon.jsx'

import { addNotification, NotificationTypes } from "../../../state/actions/notificationActions.js";

export default function UtgTools(props) {

    // Action toolbar
    const handleToolSelect = item => {
        if (item == 'copyconfig') {
            // place the config data on the users clipboard if the browser supports it
            if (navigator && navigator.clipboard && navigator.clipboard.writeText)
            {
                // alert(JSON.stringify(componentConfigData.value.componentConfig.config, null, 2))
                navigator.clipboard.writeText(JSON.stringify(props.componentConfigData.config, null, 2));
                addNotification(`The UTG configuration data has been copied to your clipboard.`, NotificationTypes.SUCCESS, false, 'Copy Succeeded')
            }
            else {
                addNotification('This browser does not support copying data to the clipboard.', NotificationTypes.INFO, false, 'Copy Failed')
            }
        }
        if (item == 'about') {
            console.log('not implemented yet')
        }
    }
    
    return (
        <Nav className="justify-content-end ms-auto" onSelect={handleToolSelect}>
        {/* <Nav.Item>
            <Nav.Link eventKey="about"><Icon icon="info-circle" width={24} height={24}></Icon> About</Nav.Link>
        </Nav.Item> */}
        <Nav.Item>
            <Nav.Link eventKey="copyconfig"><Icon icon="plus-circle" width={24} height={24}></Icon> Copy Configuration</Nav.Link>
        </Nav.Item>
        </Nav>
    )
}